import React from "react";
import { useNavigate } from "react-router-dom";

export default function UserManual() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-br from-teal-500 via-green-400 to-blue-300 text-white p-6 relative">
      {/* Top Back Button */}

      <div className="max-w-4xl mx-auto mt-16">
        <h1 className="text-4xl font-bold mb-6 text-center">User Manual</h1>

        {/* Section 1 */}
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">1. Terms and Conditions</h2>
          <p className="mb-2">
            Welcome to AICA – Your 24x7 AI-Powered Health Assistant.
            By using AICA, you agree to the following Terms and Conditions:
          </p>
          <ul className="list-disc list-inside space-y-1">
            <li><b>Eligibility:</b> AICA is intended for individuals aged 18+ or minors with parental consent. AICA is not a substitute for emergency medical services.</li>
            <li><b>Data Privacy &amp; Consent:</b> Your health data will be processed securely in compliance with local laws. By using AICA, you consent to data collection for improving care coordination.</li>
            <li><b>Medical Disclaimer:</b> AICA provides AI-generated alerts and reminders. It is not diagnostic. Always consult your doctor.</li>
            <li><b>Usage Rights:</b> Licensed to you, not sold. No reverse-engineering or misuse.</li>
            <li><b>Modifications:</b> Features may change. Continued use means acceptance.</li>
            <li><b>Limitation of Liability:</b> AICA is not liable for decisions based on AI suggestions.</li>
          </ul>
        </section>

        {/* Section 2 */}
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">2. How to Avail AICA and Its Benefits</h2>
          <ol className="list-decimal list-inside space-y-2">
            <li>
              <b>Get Access:</b> Scan the QR code. AICA is available via hospital, clinic, employer, or insurer.  
              You may also download from the AICA website.
            </li>
            <li>
              <b>Registration:</b> Enter details, link records if needed, choose language (WhatsApp/Web).  
              Reminders & confirmations are shared on WhatsApp.
            </li>
            <li>
              <b>Add Family or Caregiver:</b> Optionally give access to a family member or caregiver.
            </li>
          </ol>
        </section>

        {/* Section 3 */}
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">3. How to Activate the Benefits</h2>
          <ul className="list-disc list-inside space-y-1">
            <li>Symptom Checker: Report symptoms via voice or text anytime.</li>
            <li>Prescriptions: Auto-sent to WhatsApp if your doctor uses AICA.</li>
            <li>Medication Reminders & Alerts: Ensure notifications are enabled.</li>
            <li>24x7 Support: Ask health-related questions anytime.</li>
          </ul>
        </section>

        {/* Section 4 */}
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">4. Frequently Asked Questions (FAQs)</h2>
          <div className="space-y-2">
            <p><b>Q1:</b> Is AICA a doctor? <br /> <b>A:</b> No, it supports care but doesn’t replace doctors.</p>
            <p><b>Q2:</b> Is AICA free? <br /> <b>A:</b> Free via clinics/hospitals/insurers, or available via subscription.</p>
            <p><b>Q3:</b> Can AICA help in emergencies? <br /> <b>A:</b> It can alert you, but call 911 for emergencies.</p>
            <p><b>Q4:</b> How does AICA protect my data? <br /> <b>A:</b> HIPAA-compliant encryption, never sold.</p>
            <p><b>Q5:</b> Can I use AICA for my parents or children? <br /> <b>A:</b> Yes, multi-family member support is available.</p>
            <p><b>Q6:</b> What languages does AICA support? <br /> <b>A:</b> English, Hindi, and others.</p>
            <p><b>Q7:</b> What features are available? <br /> <b>A:</b> Care guidance, reminders, adherence reports, scheduling doctors, labs, medicine, and AI opinions on reports.</p>
          </div>
        </section>
      </div>

      {/* Bottom Back Button */}
      <div className="text-center mt-12">
        <button
          onClick={() => navigate("/")}
          className="bg-white text-teal-600 px-6 py-2 rounded-full shadow hover:bg-gray-100 transition"
        >
          Back to Home
        </button>
      </div>
    </div>
  );
}
